module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-BlackItalic.38788b87.ttf";